import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import 'rxjs/add/operator/map';
import { AppService, BASE_URL_TRANSLATION } from '../app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TranslationService extends AppService {

  constructor(private _http: HttpClient, private _translation: TranslateService) {
    super(_http);
  }

  getDataTableTranslation(): any {
    // Usage: this._translation.getDataTableTranslation().subscribe(dataTableTranslation => console.log(dataTableTranslation));
    return this._translation.get(['DATATABLE']).map(res => res['DATATABLE']);
  }

  getLocaleSettingsById(localeId: string): Observable<any> {
    this.endpoint = `${BASE_URL_TRANSLATION}/locales/${localeId}/settings`;
    return this.get(this.endpoint);
  }

  setUserLanguage(localeId: string, userId: number): Observable<any> {
    this.endpoint = `${BASE_URL_TRANSLATION}/locales/${localeId}/users/${userId}`;
    return this.post(this.endpoint, {});
  }

  getEnabledLocales(): Observable<any> {
    this.endpoint = `${BASE_URL_TRANSLATION}/locales/enabled`;
    return this.get(this.endpoint);
  }
}




// WEBPACK FOOTER //
// ./src/app/services/translation.service.ts